import "./Page.styl";

import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router";
import Match from "../components/Match";

import { Container, Row, Col, Button } from "reactstrap";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

import { get, deleteByKey } from "../../common/offer/actions";
import { setLocation } from "../../common/app/actions";

class Page extends React.Component {
  constructor() {
    super();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getOffer();
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  getOffer = async () => {
    const { get, params, setLocation, location } = this.props;

    const slug = params.slug;
    const rs = await get({ slug });
    if (rs && rs.status === 404) {
      this.redirect("/404");
      let loc = location;
      loc.pathname = "/404";
      setLocation(loc);
    }
  };

  deleteOffer = async () => {
    const { deleteByKey, params, setLocation, location } = this.props;

    const key = params.key;
    const rs = await deleteByKey({ key });
    if (rs && rs.status >= 200 && rs.status <= 299) {
      this.getOffer();
    }
  };

  render() {
    const { location, params, map, apiHost } = this.props;

    const slug = params.slug;
    const key = params.key;
    const obj = map.get(slug);

    const isDeleted = obj && obj.get("isDeleted");

    const seoTitle = "Zarządzaj Ogłoszeniem";
    const seoDescription = "Zarządzaj dodanym ogłoszeniem";

    return (
      <div className="admin-page">
        <Helmet
          title={seoTitle}
          description={seoDescription}
          meta={[
            { name: "description", content: seoDescription },
            { property: "og:type", content: "website" },
            { property: "og:title", content: seoTitle },
            { property: "og:description", content: seoDescription },
            {
              property: "og:image",
              content: "https://opiekujsie.pl/static/lockstep.jpg"
            }
          ]}
        />
        <Header />

        <div className="admin-section">
          <div className="admin-wrapper">
            <div className="image" />
            <div className="content">
              <h1>
                Twoje ogłoszenie zostało <strong>dodane pomyślnie!</strong>
              </h1>
              <div className="description">
                Tytuł ogłoszenia: {obj && obj.get("title")}
              </div>
              {!isDeleted && (
                <a className="link" href={`/oferty/${slug}`} target="_blank">
                  Pokaż ogłoszenie
                </a>
              )}
              <div className="desc">
                Z tego miejsca możesz skasować wcześniej zamieszczone
                ogłoszenie. <br />Aby wrócić do tej strony skopiuj ten link:{" "}
                <span>
                  {typeof window !== "undefined" && window.location.href}
                </span>
              </div>
              <hr />
              {isDeleted && <div>Ogłoszenie skasowane.</div>}
              {!isDeleted && (
                <div className="description">Akcje do ogłoszenia:</div>
              )}
              {!isDeleted && (
                <Button color="danger" size="lg" onClick={this.deleteOffer}>
                  Usuń ogłoszenie
                </Button>
              )}
            </div>
          </div>
        </div>

        <Footer noNewsletter />
      </div>
    );
  }
}

Page.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(
  state => ({
    apiHost: state.config.apiHost,
    map: state.offer.map
  }),
  { get, deleteByKey, setLocation }
)(Page);



/** WEBPACK FOOTER **
 ** ./src/browser/admin/Page.js
 **/